










import Vue from "vue";

export default Vue.extend({
  name: "Footer",
  data: function () {
    return {
      version: process.env.VUE_APP_PACKAGE_VERSION,
    };
  },
});
